module.exports = __webpack_public_path__ + "49819e9c7564110f4b04c9b0eb125b85.svg";